import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { userMembershipValidation } from './validation'
import dayjs from 'dayjs'

function addYearsToDate(date, years) {
  const newDate = new Date(date)
  const currentYear = newDate.getFullYear()
  newDate.setFullYear(currentYear + years)
  return newDate
}

export const useFormUserMembership = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(userMembershipValidation()),
    initialValues: {
      is_agent: false,
      is_fulfillment_client: false,
      is_partner: false,
      membership_ids: [],
      start_at: new Date(),
      expired_at: addYearsToDate(new Date(), 1),
      country_catalog_active: '',
      country_catalogs: [],
      default_shipping_to: '',
      currency: 'IDR',
      shipping_list: []
    },
    transformValues: (values) => {
      return {
        is_agent: values.is_agent,
        is_fulfillment_client: values.is_fulfillment_client,
        is_partner: values.is_partner,
        membership_ids: values.membership_ids.map((val) => Number(val)),
        start_at: dayjs(values.start_at).format('YYYY-MM-DD'),
        expired_at: dayjs(values.expired_at).format('YYYY-MM-DD'),
        country_catalog_active: Number(values.country_catalog_active),
        country_catalogs: values.country_catalogs.map((val) => Number(val)),
        shipping_list: values.shipping_list.map((val) => Number(val)),
        settings: [
          {
            key: 'default_shipping_to',
            value: values.default_shipping_to
          },
          {
            key: 'currency',
            value: values.currency
          }
        ]
      }
    }
  })
}